import { DATA_CACHE_TIMEOUT } from '../constants';

/**
 * Checks a timestamp flag stored with the data in storage for not being older
 * than the specified time amount. If true, the stored data can be re-used.
 * If false, the data is stale and has to be reloaded.
 */
export const isValidStorageTimestamp = timestamp => Date.now() - timestamp <= DATA_CACHE_TIMEOUT;
//# sourceMappingURL=isValidStorageTimestamp.js.map